export default "__VITE_ASSET__DKGmlf1Y__"